<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 class="card-title mb-0">Category List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="goToCreate"
              >Create</CButton>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search By Name"
                    :value="searchQuery"
                    @input="onSearchInput"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            :pagination="false"
          >
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-0"
                    @click="editCategory(data.item.id)"
                  >Edit</CButton>
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div class="pagination-btn-refresh" @click="fetchCategories('REFRESH')">
              Refresh
            </div>
            <div class="pagination-btn-back" @click="fetchCategories('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="fetchCategories('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

const SEARCH_DEBOUNCE_DELAY = 300;

export default {
  name: "CorporateCategory",
  data() {
    return {
      items: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "name", label: "Name" },
        { key: "status", label: "Status" },
        { key: "action", label: "Action" },
      ],
      activePage: 1,
      searchQuery: "",
      searchTimeout: null,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    if (!this.authentication()) {
      return;
    }
    this.fetchCategories();
  },
  beforeDestroy() {
    this.cancelSearchDebounce();
  },
  methods: {
    authentication() {
      const token = localStorage.getItem("token");
      const data = token ? jwt.decode(token) : null;
      const allowedGroups = ["MARKETING", "ADMIN", "ADMINISTRATOR"];

      if (data && allowedGroups.includes(data.account_group)) {
        return true;
      }

      this.$router.push({ path: "/" });
      return false;
    },
    fetchCategories(action) {
      if (this.cancelSearchDebounce() && action !== "REFRESH") {
        action = "SEARCH";
      }

      if (action === "NEXT") {
        this.activePage += 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage -= 1;
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        this.searchQuery = "";
      } else {
        this.activePage = 1;
      }

      const requestedPage = this.activePage;

      axios
        .get(`${this.domain}/v1/corporate_action_category/data`, {
          params: {
            page: requestedPage,
            per_page: 20,
            q: this.searchQuery,
          },
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const categories =
            response && response.data && Array.isArray(response.data.data)
              ? response.data.data
              : [];

          if (categories.length > 0) {
            this.items = categories.map((category) => ({
              id: category.id,
              name: category.name,
              status: category.status,
            }));
          } else if (action === "NEXT") {
            this.activePage = requestedPage - 1;
          } else if (requestedPage === 1) {
            this.items = [];
          }
        })
        .catch((error) => {
          const message =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.message.id;

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: message || "Terjadi kesalahan saat memuat kategori.",
          });
      });
    },
    onSearchInput(query) {
      this.searchQuery = query;
      this.activePage = 1;
      this.cancelSearchDebounce();
      this.searchTimeout = setTimeout(() => {
        this.searchTimeout = null;
        this.fetchCategories("SEARCH");
      }, SEARCH_DEBOUNCE_DELAY);
    },
    cancelSearchDebounce() {
      if (this.searchTimeout === null) {
        return false;
      }

      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
      return true;
    },
    goToCreate() {
      this.$router.push({ path: "/management/corporate-category/create" });
    },
    editCategory(id) {
      this.$router.push({ path: `/management/corporate-category/${id}` });
    },
  },
};
</script>

<style scoped>
@import url("./CorporateCategory.css");
</style>
